export * from "@chakra-ui/react"; // Exports Chakra components first to override some components later

// Exporting our own components with "BS" suffix to allow use of both Chakra and Biblioteksentralen components in the same project
export { AlertBS } from "./components/AlertBS";
export { ButtonBS, type ButtonBSProps } from "./components/ButtonBS";
export { IconButtonBS, type IconButtonBSProps } from "./components/IconButtonBS";
export { InputBS } from "./components/InputBS";
export { ConditionalWrapperBS } from "./components/ConditionalWrapperBS";
export { ErrorBoundaryBS } from "./components/ErrorBoundaryBS";
export { HashLinkTargetBS } from "./components/HashLinkTargetBS";
export { withErrorBoundaryBS } from "./components/withErrorBoundaryBS";
export { BiblioteksentralenProvider } from "./BiblioteksentralenProvider";

export { colors } from "@biblioteksentralen/utils"; // Re-export colors for convenience
